import DeviceStorage from '../libs/device-storage';
import ResponseHelper from '../libs/api/response-helper';

/* User data store */

export const state = () => ({
  user: DeviceStorage.get('user') || {
    id: '',
    name: '',
    username: '',
    socialName: '',
    linkedin: '',
    profilePicture: '',
    city: '',
    state: '',
    country: '',
    profileCompleted: '',
    age: '',
    incompleteProfile: false,
    anonymous: false,
    metadata: {
      arenaId: ''
    }
  },
  session: DeviceStorage.get('session') || {
    token: '',
    refreshToken: '',
    deviceManagementId: ''
  },
  cookies: {
    acceptance: false
  },
  sigupType: []
});

export const mutations = {
  setUser(state, payload) {
    state.user.id = payload.id;
    state.user.name = payload.name;
    state.user.socialName = payload.socialName;
    state.user.linkedin = payload.linkedin;
    state.user.profilePicture = payload.profilePicture;
    state.user.city = payload.city;
    state.user.state = payload.state;
    state.user.country = payload.country;
    state.user.profileCompleted = payload.profileCompleted;
    state.user.age = payload.age;
    state.user.incompleteProfile = !!payload.incompleteProfile;
    state.user.anonymous = !!payload.anonymous;
    if (payload.username) {
      state.user.username = payload.username;
    }
    if (payload.metadata.arenaId) {
      state.user.metadata.arenaId = payload.metadata.arenaId;
    }
    DeviceStorage.set('user', state.user);
  },

  setSession(state, { token, deviceManagementId, refreshToken }) {
    if (token === undefined || deviceManagementId === undefined) return;
    state.session.token = token;
    state.session.refreshToken = refreshToken;
    state.session.deviceManagementId = deviceManagementId;
    DeviceStorage.set('session', state.session);
  },

  setCookiesAcceptance(state, acceptance) {
    state.cookies.acceptance = acceptance;
  },

  setSignupTypes(state, types) {
    state.sigupType = types;
    DeviceStorage.set('signupTypes', state.sigupType);
  },

  clearSession(state) {
    state.user = {
      id: '',
      name: '',
      username: '',
      socialName: '',
      linkedin: '',
      profilePicture: '',
      city: '',
      state: '',
      country: '',
      profileCompleted: '',
      age: '',
      incompleteProfile: false,
      anonymous: false,
      metadata: {}
    };
    state.session = {
      token: '',
      refreshToken: '',
      deviceManagementId: ''
    };
    state.sigupType = [];
    DeviceStorage.remove('user');
    DeviceStorage.remove('session');
    DeviceStorage.remove('signupTypes');
  }
};

export const actions = {
  login(
    { state, rootState, commit },
    { user, pass, sharedDevice, anonymous, deviceInfo, language, country }
  ) {
    return this.$api.auth
      .login(
        rootState.config.distributor.id,
        user,
        pass,
        anonymous,
        deviceInfo,
        language,
        country
      )
      .then((response) => {
        if (response.code === 0 && response.data) {
          const d = response.data;
          commit('setUser', {
            id: d.id,
            name: d.name,
            socialName: d.socialName,
            linkedin: d.linkedin,
            profilePicture: d.profilePicture,
            city: d.city,
            state: d.state,
            country: d.country,
            profileCompleted: d.profileCompleted,
            age: d.age,
            username: user,
            incompleteProfile: d.incompleteProfile,
            anonymous,
            metadata: {
              arenaId: d.arenaId
            }
          });
          commit('setSession', {
            token: d.token,
            refreshToken: d.refreshToken,
            deviceManagementId: d.deviceManagementId
          });

          commit('setSignupTypes', d.signupTypes || []);

          if (!sharedDevice) {
            DeviceStorage.set('user', state.user);
            DeviceStorage.set('session', state.session);
          }
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      });
  },

  redirectToGovLogin({ rootState }) {
    const { data } = rootState.distributor.data;

    return this.$api.auth.redirectToGovLogin(
      data.govClientId,
      data.govRedirectUri,
      rootState.config.govLoginEnvironment
    );
  },

  govLogin({ rootState, commit, state }, payload) {
    return this.$api.auth
      .govLogin({
        ...payload,
        distributorId: rootState.config.distributor.id
      })
      .then((response) => {
        if (response.code === 0 && response.data) {
          DeviceStorage.set('govLoginErrorCount', 0);
          const d = response.data;

          commit('setUser', {
            id: d.id,
            name: d.name,
            socialName: d.socialName,
            linkedin: d.linkedin,
            profilePicture: d.profilePicture,
            city: d.city,
            state: d.state,
            country: d.country,
            profileCompleted: d.profileCompleted,
            age: d.age,
            username: d.username,
            incompleteProfile: d.incompleteProfile,
            anonymous: false,
            metadata: {
              arenaId: d.arenaId
            }
          });

          commit('setSession', {
            token: d.token,
            refreshToken: d.refreshToken,
            deviceManagementId: d.deviceManagementId
          });
          commit('setSignupTypes', d.signupTypes || []);

          DeviceStorage.set('user', state.user);
          DeviceStorage.set('session', state.session);
          return Promise.resolve(response);
        }
        return Promise.reject(ResponseHelper.getErrorResponse(response));
      })
      .catch((err) => {
        const currentCount = DeviceStorage.get('govLoginErrorCount') || 0;
        DeviceStorage.set('govLoginErrorCount', currentCount + 1);

        return Promise.reject(ResponseHelper.getErrorResponse(err));
      });
  },

  logout({ commit, state }) {
    let tokenToValidate;
    if (state.session.token) {
      tokenToValidate = state.session.token;
    } else {
      const sessionInDevice = DeviceStorage.get('session');
      tokenToValidate = sessionInDevice?.token;
    }
    commit('clearSession');
    return this.$api.auth.logout(tokenToValidate);
  },

  check({ commit, state }) {
    let tokenToValidate;
    if (state.session.token) {
      tokenToValidate = state.session.token;
    } else {
      const sessionInDevice = DeviceStorage.get('session');
      tokenToValidate = sessionInDevice?.token;
    }
    if (tokenToValidate) {
      return this.$api.auth
        .isLoggedIn(tokenToValidate)
        .then((response) => {
          if (response.code === 0 && response.data) {
            const d = response.data;
            commit('setUser', {
              id: d.id,
              name: d.name,
              username: d.username,
              socialName: d.socialName,
              linkedin: d.linkedin,
              profilePicture: d.profilePicture,
              city: d.city,
              state: d.state,
              country: d.country,
              profileCompleted: d.profileCompleted,
              age: d.age,
              incompleteProfile: d.incompleteProfile,
              anonymous: state.user.anonymous,
              metadata: {
                arenaId: d.metadata.arenaId
              }
            });
            commit('setSession', {
              token: d.token,
              refreshToken: d.refreshToken || state.session.refreshToken,
              deviceManagementId: d.deviceManagementId
            });
            return Promise.resolve(response.message || 'OK');
          }
          return Promise.reject(
            response.message || 'Servidor não informou mensagem de resposta.'
          );
        })
        .catch((response) => {
          return Promise.reject(ResponseHelper.getErrorResponse(response));
        });
    }
    return Promise.reject('Informe seu usuário e senha para prosseguir.');
  },

  acceptCookies({ commit, state }) {
    commit('setCookiesAcceptance', {
      acceptance: true
    });
    DeviceStorage.set('cookies', state.cookies.acceptance);
  },

  checkCookies() {
    let check;
    check = DeviceStorage.get('cookies');
    return !!check;
  },

  getSession() {
    const session = DeviceStorage.get('session');
    return Promise.resolve(session);
  },

  getUser() {
    const user = DeviceStorage.get('user');
    return Promise.resolve(user);
  },

  getSignupTypes() {
    const types = DeviceStorage.get('signupTypes');
    return Promise.resolve(types || []);
  },

  getUserUname({ commit, state }, payload) {
    return this.$api.auth
      .getUserUname(payload.uname, state.session.token)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((err) => {
        return Promise.reject(ResponseHelper.getErrorResponse(err));
      });
  }
};
